// UI monolíngue por ora: o texto vem do bundle pt-BR direto, não do i18next
// (ver i18n/README.md — trocar o idioma padrão é trocar este caminho).
import type { GuardianRelationship } from '@/types/parental-consent';
import parentalConsent from '@/i18n/locales/pt-BR/parentalConsent.json';

export const parentalConsentCopy = {
  productName: 'identila',
  title: parentalConsent.title,
  subtitle: parentalConsent.subtitle,
  minorBannerLabel: (fullName: string) =>
    parentalConsent.minorBannerLabel.replace('{{fullName}}', fullName),
  guardianFullNameLabel: parentalConsent.guardianFullNameLabel,
  guardianFullNamePlaceholder: parentalConsent.guardianFullNamePlaceholder,
  guardianEmailLabel: parentalConsent.guardianEmailLabel,
  guardianEmailPlaceholder: parentalConsent.guardianEmailPlaceholder,
  guardianCpfLabel: parentalConsent.guardianCpfLabel,
  guardianCpfPlaceholder: parentalConsent.guardianCpfPlaceholder,
  guardianPhoneLabel: parentalConsent.guardianPhoneLabel,
  guardianPhonePlaceholder: parentalConsent.guardianPhonePlaceholder,
  guardianRelationshipLabel: parentalConsent.guardianRelationshipLabel,
  guardianRelationshipPlaceholder: parentalConsent.guardianRelationshipPlaceholder,
  consentLabel: parentalConsent.consentLabel,
  cta: parentalConsent.cta,
  ctaLoading: parentalConsent.ctaLoading,
  backLink: parentalConsent.backLink,
  securityMessage: parentalConsent.securityMessage,
} as const;

export const guardianRelationshipOptions: ReadonlyArray<{
  value: GuardianRelationship;
  label: string;
}> = [
  { value: 'father', label: parentalConsent.relationships.father },
  { value: 'mother', label: parentalConsent.relationships.mother },
  { value: 'legal_tutor', label: parentalConsent.relationships.legal_tutor },
  { value: 'legal_guardian', label: parentalConsent.relationships.legal_guardian },
];

export const parentalConsentValidationMessages = parentalConsent.validation;
